<template>
    <section>
        <template v-if="itemsCount">
            <div class="popup-cart-header__scroll-content">
                <client-only>
                    <PerfectScrollbar ref="scrollbar">
                        <CheckoutCart
                            :bem-modifiers="['mobile']"
                            :loader-target="loaderTarget"
                        />
                    </PerfectScrollbar>
                </client-only>
            </div>
            <div class="popup-cart-header__total">
                <span>Razem:</span>
                <div class="popup-cart-header__total-price">
                    <PriceValue
                        v-if="totalPrice"
                        :value="totalPrice"
                    />
                    <PriceCurrency />
                </div>
            </div>
            <CartNotCompatibleInfo
                v-if="isMultisource"
                class="popup-cart-header__cart-not-compatible"
            />
            <div class="popup-cart-header__actions">
                <ButtonBase
                    :bem-modifiers="['blue']"
                    @click="handleClick(checkoutCartUrl)"
                >
                    {{ cartButtonText }}
                </ButtonBase>
                <ButtonBase
                    v-if="!isMultisource"
                    :bem-modifiers="['red']"
                    @click="handleClick(checkoutOnepageUrl)"
                >
                    Zamów
                </ButtonBase>
            </div>
        </template>
        <EmptyListCartHeader v-else-if="!needFetch" />
        <LoaderCastoramaC
            v-else
            bem-modifiers="page-content-placeholder"
        />
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ButtonBase from '~/src/components/ui/Button/ButtonBase';
import CartNotCompatibleInfo from '~/src/components/CartNotCompatibleInfo';
import PriceCurrency from '~/src/components/Price/PriceCurrency';
import PriceValue from '~/src/components/Price/PriceValue';
import pagesUrl from '~/assets/services/cmsPagesUrl';
import LoaderCastoramaC from '~/src/components/ui/Loader/LoaderCastoramaC';

const { checkoutCart: checkoutCartUrl, checkoutOnepage: checkoutOnepageUrl } = pagesUrl;

const {
    mapState: mapStateCart,
} = createNamespacedHelpers('cart2');
export default {
    name: 'PopupCartHeader',
    components: {
        EmptyListCartHeader: () => import('~/components/common/Header/CartHeader/component/EmptyListCartHeader' /* webpackChunkName: "popup/empty-list-cart-header" */),
        ButtonBase,
        PriceValue,
        CartNotCompatibleInfo,
        PriceCurrency,
        CheckoutCart: () => import('~/src/components/checkout/Cart' /* webpackChunkName: "checkout-cart" */),
        LoaderCastoramaC,
    },
    props: {
        /**
         * Loader target
         */
        loaderTarget: {
            type: null,
            default: undefined,
        },
    },
    data() {
        return {
            checkoutCartUrl,
            checkoutOnepageUrl,
            dataLoaded: false,
        };
    },
    computed: {
        ...mapStateCart({
            itemsCount: state => state.itemsCount,
            needFetch: state => state.needFetch,
            totalPrice: state => state.totalPrice,
            isMultisource: state => state.isMultisource,
        }),
        cartButtonText() {
            return this.isMultisource ? 'Sprawdź koszyk' : 'Do koszyka';
        },
    },
    mounted() {
        this.updateScroll();
    },
    updated() {
        this.updateScroll();
    },
    methods: {
        updateScroll() {
            if (this.itemsCount > 1 && this.$refs.scrollbar) {
                this.$refs.scrollbar.update();
            }
        },
        handleClick(pathWithHost) {
            window.location.href = pathWithHost;
        },
    },
};
</script>
<style lang="scss">
.popup-cart-header {
    &__scroll-content {
        outline: none;
        margin-top: 24px;

        .ps {
            padding: 0 $spacing-small;
            min-height: 133px;
            max-height: 399px;

            .tooltip--move-left .tooltip-inner {
                margin-left: -100px;
            }
        }
    }

    &__total {
        display: flex;
        place-content: space-between;
        margin: 0 24px;
        border-bottom: 1px solid $color-slate10;
        color: $color-slate100;
        font-weight: $font-weight-bold;
        font-size: 20px;
        line-height: 27px;
        padding: 16px 0;

        &-price {
            color: $color-deepCanynon-dark;
        }
    }

    &__cart-not-compatible {
        margin-left: 17px;
        margin-top: 24px;
    }

    &__actions {
        display: flex;
        place-content: space-between;

        button {
            width: 50%;
        }
    }
}
</style>
